module.exports = __webpack_public_path__ + "static/files/cartoon_stories_1.c260abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cartoon_stories_1.png
// module id = QtrZ
// module chunks = 0